import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import { URL_PATHS } from "constants/index"
import { Link, generatePath } from "react-router-dom"

const bookingReportListColumns = ({ type, eventId }) => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, item) => <>{item?.id}</>,
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.name}</>,
    },
    {
      text: "# of Bookings",
      dataField: "bookings_count",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) =>
        item?.bookings_count > 0 ? (
          <Link
            to={{
              pathname: generatePath(URL_PATHS.BOOKING_REPORTS, {
                event_id: eventId,
              }),
              search: `?${
                type === "calendar-group" ? "calendar_id" : "booking_type_id"
              }=${item?.id}`,
            }}
          >
            {item?.bookings_count}
          </Link>
        ) : (
          <span className="text-primary">{item?.bookings_count}</span>
        ),
    },
    {
      text: "Revenue",
      dataField: "revenue",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>{parseFloat(item?.revenue)?.toFixed(2)}</>
      ),
    },
  ]
}

export default bookingReportListColumns
